/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signuptypecheckbox2Inputs */

const en_signuptypecheckbox2 = /** @type {(inputs: Signuptypecheckbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkbox (yes/no)`)
};

const de_signuptypecheckbox2 = /** @type {(inputs: Signuptypecheckbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Häkchen (Ja/Nein)`)
};

/**
* | output |
* | --- |
* | "Checkbox (yes/no)" |
*
* @param {Signuptypecheckbox2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signuptypecheckbox2 = /** @type {((inputs?: Signuptypecheckbox2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signuptypecheckbox2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signuptypecheckbox2(inputs)
	return de_signuptypecheckbox2(inputs)
});
export { signuptypecheckbox2 as "signupTypeCheckbox" }